<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="container">
      <vgtree ref="xTree" class="vgtree" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick">
          <template slot="btn">
              <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
          </template>
      </vgtree>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vgtree from '../common/vgtree1'
  import MenuBtn from "../common/menuBtn"
  export default {
    name: 'womIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btnLoading: false,
        wmenuList: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80},
          { field: 'wmenuname', fieldtype: 'C', title: '名称',calculExpr:''}
        ],
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          total: 0,
          currPage: 1,
          pageSize: 20
        },
        wmenu: {},
        loading: true,
        formLabelWidth: '100px'
      }
    },
    activated() {
      this.getWmenuTree()
    },
    created () {
      this.$on('PICSET', () => this.setCarfig())
      this.$on('PUBLIC', () => this.setPublic())
      this.$on('CLOSE', () => this.close())
    },
    mounted () {
    },
    watch: {
      $route() {
      }
    },
    components: {MenuBtn,vgtree},
    methods: {
      initform() {
      },
      btnClick (code) {
        this.$emit(code)
      },
      async setCarfig () {
        if (!this.wmenu.wmenuid) {
          this.$message.warning('请选择一个网站菜单!')
          return
        }
        this.$router.push({name: 'carfigIndex', params: {form: this.wmenu}})
      },
      async setPublic() {
        if (!this.wmenu.wmenuid) {
          this.$message.warning('请选择一个网站菜单!')
          return
        }
        
        this.$router.push({name: 'noticeIndex', params: {form: this.wmenu}})
      },
      async cellClick (row) {
        this.initform()
        this.wmenu = row.row
      },
      async getWmenuTree () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/wmenu/getWmenuTree',
          params: {cosid: this.$store.getters.loginUser.cosid}
        })
        this.list = res.list
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .vgtree {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .vggrid {
      margin-left: 50px;
      width: 800px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
</style>
